























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getUsers, deleteUser } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import User from '../models/User';
import get from 'lodash/get';
import { roles, formatRoles } from '@/data/roles';
import Datatable from '@/components/Datatable.vue';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';

@Component({
    filters: {
        formatRoles,
        formatDate: (value: string) => {
            return value ? moment(value).format('DD/MM/YYYY - kk:mm') : null;
        },
    },
    components: {
        Datatable,
    },
})
export default class Users extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            year: new Date().getFullYear() // Année courante par défaut
        },
        exclusions: {
            role: 'ROLE_PRESCRIBER',
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);

    columns: HeaderDatatable[] = [
        {
            title: 'Nom',
            dataIndex: 'lastname',
            sorter: true,
            scopedSlots: {
                customRender: 'lastname',
            },
        },
        {
            title: 'Email',
            dataIndex: 'email',
            sorter: true,
        },
        {
            title: 'Téléphone',
            dataIndex: 'phone',
            sorter: true,
        },
        {
            title: 'Mobile',
            dataIndex: 'mobile',
            sorter: true,
        },
        {
            title: 'Role',
            dataIndex: 'roles',
            sorter: true,
            scopedSlots: {
                customRender: 'roles',
            },
        },
        {
            title: 'Entreprise',
            dataIndex: 'company',
            scopedSlots: {
                customRender: 'company',
            },
            sorter: true,
        },
        {
            title: 'Dernière connexion',
            dataIndex: 'last_login',
            scopedSlots: {
                customRender: 'date',
            },
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];

    async fetch(meta: MetaDatatable) {
        const { data } = await getUsers({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }

    deleteText = {
        confirm: {
            title: `Suppression de l'utilisateur`,
            content: `Voulez-vous vraiment supprimer l'utilisateur ?`,
        },
        notify: {
            title: 'Utilisateur supprimé',
            content: `L'utilisateur a bien été supprimé`,
        },
    };

    // Génération de la liste des années (de 2020 à année courante + 1)
    get years() {
        const currentYear = new Date().getFullYear();
        const startYear = 2020; // Vous pouvez ajuster selon vos besoins
        const years = [];

        for (let year = currentYear + 1; year >= startYear; year--) {
            years.push(year);
        }

        return years;
    }

    get roles() {
        const filterdRoles = Object.keys(roles).filter(
            key => key !== 'ROLE_PRESCRIBER'
        );
        return filterdRoles.map(role => ({
            value: role,
            text: get(roles, role),
        }));
    }

    onFilterYear(value: number | undefined) {
        if (value) {
            this.meta.filters = {
                ...this.meta.filters,
                year: value,
            };
        } else {
            // Supprime le filtre année mais garde les autres filtres
            if (this.meta.filters) {
                const filters = { ...this.meta.filters };
                delete filters.year;
                this.meta.filters = Object.keys(filters).length > 0 ? filters : null;
            }
        }
    }

    onFilterRole(value: string | undefined) {
        if (value) {
            this.meta.filters = {
                ...this.meta.filters,
                role: value,
            };
        } else {
            // Supprime le filtre rôle mais garde les autres filtres
            if (this.meta.filters) {
                const filters = { ...this.meta.filters };
                delete filters.role;
                this.meta.filters = Object.keys(filters).length > 0 ? filters : null;
            }
        }
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: User | null;
    }) {
        const action = ev.action;
        const user: User | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                if (user !== null) {
                    this.$router.push({
                        name: 'editUser',
                        params: {
                            id: `${user.id}`,
                        },
                    });
                }
                break;
            case 'delete':
                if (user && user.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                        exclusions: {
                            role: 'ROLE_PRESCRIBER',
                        },
                    };
                    await deleteUser(user.id);
                }
                break;
        }
    }

    deleteDialog(user: User) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(user),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(user: User) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: user });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de l'utilisateur`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    filterOption(input: any, option: any) {
        return (
            option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
    }

    // Models pour les selects
    typeModel: string | undefined | null = null;
    yearModel: number | undefined | null = null;

    created() {
        this.typeModel = undefined;
        this.yearModel = new Date().getFullYear(); // Année courante par défaut
    }

    @Watch('meta', { deep: true })
    onMeta() {
        // Synchronisation du filtre rôle
        if (this.meta.filters && this.meta.filters.role) {
            this.typeModel = this.meta.filters.role;
        } else {
            this.typeModel = undefined;
        }

        // Synchronisation du filtre année
        if (this.meta.filters && this.meta.filters.year) {
            this.yearModel = this.meta.filters.year;
        } else {
            this.yearModel = undefined;
        }
    }
}
